import { useAuthenticationStore } from '@cplug/frontend-shared-domains/domain/authentication'
import { useWhitelabelStore } from '@cplug/frontend-shared-domains/domain/whitelabel'
import type { RouteLocation, RouteLocationRaw } from 'vue-router'
import { useLegacyHandoff } from '~/domain/shared/authentication/composables/useLegacyHandoff'
import { buildCleanLocation, readUrlHandoffParams } from '~/domain/shared/authentication/composables/useUrlHandoff'

export interface UrlSetupResult {
  cleanLocation?: RouteLocationRaw
  handoff?: Promise<boolean>
}

/**
 * Aplica os params de setup que o ERP legado manda na URL.
 *
 * Síncrono de propósito: quem chama decide como navegar para `cleanLocation` e se
 * espera por `handoff`. A company é setada antes do handoff porque o header
 * `CPlug-Company-Id` é montado a partir dela e vai nas requisições da troca.
 */
export function useUrlSetup (route: RouteLocation): UrlSetupResult {
  const params = readUrlHandoffParams(route)

  if (params.companyId != null) {
    useAuthenticationStore().setCompanies([{ id: params.companyId, name: '', documents: [], contacts: [] }])
    useWhitelabelStore().settings = undefined
  }

  return {
    cleanLocation: buildCleanLocation(route),
    handoff: params.refreshToken.length > 0 ? useLegacyHandoff(params.refreshToken) : undefined
  }
}
